<!-- section template -->
<template>
  <div 
    v-loading="$isLoading('fetchPrepaidOrderList') || $isLoading('fetchReservationList')"
    :class="$style.formReservationStore"
  >
    <div class="formReservationStore__topBox">
      <v-date-picker
        ref="date"
        v-model="FormMixSubmitData.date"
        v-loading="$isLoading('fetchReservationCalendar')"
        class="isStyleForm"
        :class="{ 'isStyleDingBeauty': $globalIsDingBeauty }"
        :min-date="new Date()"
        :disabled-dates="[
          { 
            weekdays: getDefaultReservationDisabledDayList({ storeAlias: storeItem.alias, type: 'v-date-picker' }),
          },
          ...currentDisabledDate,
        ]"
        is-expanded
        :masks='{ title: "YYYY年 MM月" }'
        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
        @update:from-page="onChangePage"
        @input="onChangeDate"
      >
      </v-date-picker>
    </div>
    <ValidationObserver v-slot="{ invalid, handleSubmit }" ref="vo">
      <el-form
        ref="form"
        :model="FormMixSubmitData"
        label-position="top"
        class="isStyleBase"
        @submit.prevent.native="handleSubmit(onSubmit)"
      >
        <div class="formReservationStore__bottomBox">
          <ValidationProvider
            v-slot="{ errors }"
            class="d-lg-none"
            name="預約日期"
            rules="require"
          >
            <el-form-item :error="isIncludDisabledDayList ? '該日期非營業時間，請選擇其他日期' : errors[0]" prop="date" label="預約日期">
              <el-date-picker
                ref="datePicker"
                v-model="FormMixSubmitData.date"
                type="date"
                :editable="false"
                :clearable="false"
                :prefix-icon="'none'"
                :format="`[${formatDate(FormMixSubmitData.date, 'dateWeekDay')}]`"
                :popper-class="`${$isLoading('fetchReservationCalendar') ? 'isLoading' : $globalIsDingBeauty ? 'isStyleSquare' : ''}`"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                placeholder="預約日期"
                @change="onChangeDate"
                @focus="onFocus"
              >
              </el-date-picker>
            </el-form-item>
          </ValidationProvider>
        
          <template v-if="currentMerchant.cosmeticSetting.canSpecifyScheduleItem">
            <ValidationProvider
              v-slot="{ errors }"
              name="美容師"
            >
              <el-form-item :error="errors[0]" prop="scheduleItemId" :label="$globalIsDingBeauty || $globalWindowWidth <= 991 ? '美容師' : ''">
                <el-select
                  v-model="FormMixSubmitData.scheduleItemId"
                  placeholder="選擇美容師"
                  :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                  @change="onChangescheduleItemId"
                >
                  <el-option
                    v-for="(option, $index) in scheduleItemIdOptions"
                    :key="`scheduleItemIdOptions-${$index}`"
                    :label="option.name"
                    :value="option.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
          </template>
          <div v-if="!!FormMixSubmitData.isUserMemberPet">
            <template v-if="!!currentMemberPetList && !!currentMemberPetList[0]">
              <ValidationProvider
                v-slot="{ errors }"
                :name="`我的${$t('site.USER')}`"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="petId" :label="$globalIsDingBeauty || $globalWindowWidth <= 991 ? `我的${$t('site.USER')}` : ''">
                  <el-select
                    v-model="FormMixSubmitData.petId"
                    :placeholder="`請選擇${$t('site.USER')}`"
                    class="isStylePet2"
                    popper-class="isStylePet"
                    @change="onChangePetId"
                  >
                    <div slot="prefix">
                      <span
                        class="prefix__img"
                        :style="{ backgroundImage: `url('${ memberPetItem.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
                      ></span>
                      <span class="prefix__meta">
                        <span class="prefix__title">
                          {{ memberPetItem.text }}
                        </span>
                        <span v-if="$globalCategoryVisible" class="prefix__category">
                          {{ memberPetItem.categoryTitle }} | {{ memberPetItem.sizeTitle }}
                        </span>
                      </span>
                    </div>
                    <el-option
                      v-for="(option, $index) in memberPetOptions"
                      :key="`memberPetOptions-${$index}`"
                      :label="option.text"
                      :value="option.value"
                    >
                      <div class="option__item">
                          <span
                            class="option__img"
                            :style="{ backgroundImage: `url('${ option.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
                          ></span>
                        <span class="option__content">
                            <span class="option__text">{{ option.text }}</span>
                            <span v-if="$globalCategoryVisible" class="option__category">{{ option.categoryTitle }} | {{ option.sizeTitle }}</span>
                          </span>
                      </div>
                    </el-option>
                    <el-option
                      :label="`新增${$t('site.USER')}`"
                      value="new"
                      class="isNew"
                    >
                      <i class="fal fa-plus mr-2"></i>新增{{ $t('site.USER') }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </template>
            <template v-else>
              <span>
                <div class="el-form-item">
                  <!--<label class="el-form-item__label">我的寵物(請先新增寵物)</label>-->
                  <BaseButton
                    class="isStyleSecondary isFull"
                    :class="{ 'isRadius': $globalIsJtails }"
                    @click="openDialogPet"
                  >
                    <i class="fal fa-plus"></i> 新增{{ $t('site.USER') }}
                  </BaseButton>
                </div>
              </span>
            </template>
          </div>
          <div v-else>
            <template v-if="categoryOptions.length > 1">
              <ValidationProvider
                v-slot="{ errors }"
                name="類型"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="category" :label="$globalIsDingBeauty || $globalWindowWidth <= 991 ? '類型' : ''">
                  <el-select
                    v-model="FormMixSubmitData.category"
                    placeholder="無類型"
                    :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                    @change="onChangeCategory"
                  >
                    <el-option
                      v-for="(option, $index) in categoryOptions"
                      :key="`categoryOptions-${$index}`"
                      :label="option.text"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </template>
            <template v-if="categoryOptions[0].children.length > 1">
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('site.USER_SIZE')"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="size" :label="$globalIsDingBeauty || $globalWindowWidth <= 991 ? $t('site.USER_SIZE') : ''">
                  <el-select
                    v-model="FormMixSubmitData.sizeAlias"
                    :placeholder="`無${$t('site.USER_SIZE')}`"
                    :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                    @change="onChangeSize"
                  >
                    <el-option
                      v-for="(option, $index) in sizeOptions(FormMixSubmitData.category)"
                      :key="`sizeOptions-${$index}`"
                      :label="option.text"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </template>
          </div>
          <ValidationProvider
            v-slot="{ errors }"
            :name="`選擇我的${$t('site.USER')}`"
            rules=""
          >
            <el-form-item :error="errors[0]" prop="isUserMemberPet" label="" style="margin-top: -0.25rem">
              <el-checkbox
                v-model="FormMixSubmitData.isUserMemberPet"
                :class="{ 'isStyleDingBeauty': $globalIsDingBeauty }"
                @change="onChangeIsUserMemberPet"
              >
                {{`選擇我的${$t('site.USER')}`}}
              </el-checkbox>
            </el-form-item>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name=" `使用我的${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}`"
            rules=""
            v-if="currentMerchant.prepaidSetting.isEnabled"
          >
            <el-form-item :error="errors[0]" prop="isUsePrepaid" label="" style="margin-top: -1.5rem">
              <el-checkbox
                v-model="FormMixSubmitData.isUsePrepaid"
                :class="{ 'isStyleDingBeauty': $globalIsDingBeauty }"
                @change="onChangeIsUsePrepaid"
              >
                {{`使用我的${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}`}}
              </el-checkbox>
            </el-form-item>
          </ValidationProvider>

        </div>
        <div v-if="invalid || !petIdValid || isIncludDisabledDayList" class="formReservationStore__submitBox">
          <BaseButton
            disabled
            :loading="$isLoading('fetchApplicablePrepaidOrderList') || $isLoading('fetchReservationList')"
            type="submit"
            class="isStylePrimary isFull formReservationStore__submit"
            :class="{ 'isRadius': $globalIsJtails }"
          >
            <span v-if="invalid">店休日，請選其他日期</span>
            <span v-if="!petIdValid">請先新增{{$t('site.USER')}}資訊</span>
            <span v-if="isIncludDisabledDayList">店休日，請選其他日期</span>
            <!-- <span v-else v-html="buttonText"></span> -->
          </BaseButton>
        </div>
      </el-form>
    </ValidationObserver>
    <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
  </div>
</template>

<script>
import formatDate from '@utils/format-date'
import formMixin from "./mixins/form";
import addDays from "date-fns/addDays";
import getISODay from "date-fns/getISODay";
import parseISO from "date-fns/parseISO";
import lastDayOfMonth from 'date-fns/lastDayOfMonth'
import isThisMonth from 'date-fns/isThisMonth'
import isThisYear from 'date-fns/isThisYear'
import _debounce from "lodash/debounce";
import { authComputed, merchantComputed } from '@store/helpers'
import {
  getDefaultCategoryAlias,
  getDefaultDate,
  getDefaultIsUsePrepaid,
  getDefaultIsUserMemberPet,
  getDefaultPetId,
  getDefaultReservationDisabledDayList,
  getDefaultSizeAlias
} from "@utils/ipetbooking-get-default";
import {
  categoryOptions,
  getMemberPetOption,
  memberPetOptions,
  sizeOptions,
  storeOptions
} from "@utils/ipetbooking-options";
import { reservationTimeButtonList } from "@utils/ipetbooking-reservation";

const DEFAULT_SUBMIT_DATA = {
  storeAlias: '',
  time: '',
  date: formatDate(new Date(), 'yyyy-MM-dd'),
  category: '',
  sizeAlias: '',
  petId: '',
  isUserMemberPet: false,
  isUsePrepaid: false,
  scheduleItemId: '',
  // 發票
  taxType:''
};

export default {
  name:'FormReservationStore.Jtails',
  components: {
    InputRadioTime: () => import("@components/Input/InputRadioTime"),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    storeItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    buttonText: {
      type: String,
      default: '查看可預約的服務',
    },
    tempSubmitData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availableTimes: {
      type: Array,
      default: () => {
        return ['10', '11']
      }
    },
    serviceType: {
      type: String,
      default: 'cosmetic',
      validator(value) {
        return [
          'cosmetic',
          'daycare',
        ].includes(value)
      },
    }
  },
  data() {
    return {
      storeOptions: Object.freeze(storeOptions({
        type: 'open'
      })),
      categoryOptions: Object.freeze(categoryOptions()),
      datePickerYear: '',
      datePickerMonth: '',
      startDate: '',
      endDate: '',
      currentDisabledDate: [],
      formatDisabledDateTime: [],
      isLoadingDateTimePicker: '',
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    memberPetOptions,
    disabledDayList() {
      return getDefaultReservationDisabledDayList({
        storeAlias: this.storeItem.alias,
        type: 'element'
      })
    },
    isIncludDisabledDayList() {
      return this.disabledDayList.includes(getISODay(parseISO(this.FormMixSubmitData.date))
        .toString());
    },
    petIdValid() {
      const isUserMemberPet = this.FormMixSubmitData.isUserMemberPet;
      const hasPetId = this.FormMixSubmitData.petId;

      return !isUserMemberPet || (!!isUserMemberPet && !!hasPetId)
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          // this.currentDisabledDate.includes(time)
          const diaabledDayList = this.disabledDayList;

          return time.getTime() < addDays(new Date(), -1) || this.formatDisabledDateTime.includes(time.getTime()) || diaabledDayList.includes(getISODay(time)
            .toString())
        },
      }
    },
    memberPetItem() {
      return getMemberPetOption({
        value: this.FormMixSubmitData.petId,
        type: 'item'
      })
    },
    timeButtonList() {
      const day = getISODay(parseISO(this.FormMixSubmitData.date));
      return reservationTimeButtonList({
        date: this.FormMixSubmitData.date,
        storeType: this.storeItem.storeType,
        ...this.storeItem.params.serviceTimeSetting[day]
      })
    },
    /**
     * @description 上面有月曆，下面的指定美容師下拉
     */
    scheduleItemIdOptions() {
      const normalArr = [
        ...this.storeItem?.scheduleItems
      ]
      if(this.$globalIsShowRandomScheduleItem){
        normalArr.unshift({
          id: '',
          name:"不指定",
          title: "不指定美容師",
          avatar: require('@assets/images/jtails/reservation/person.svg')
        })
      }
      return normalArr
    }
  },
  watch: {
    'FormMixSubmitData.petId'(newValue, oldValue) {
      if(newValue === 'new') {
        this.FormMixSubmitData.petId = oldValue;

        this.openDialogPet()
      }
    },
    'FormMixSubmitData.date': {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.FormMixSubmitData.date = newValue || oldValue
        })
      }
    },
    startDate: {
      immediate: true,
      handler(newValue, oldValue) {
        this.tryToFetchReservationCalendar()
      }
    },
    'FormMixSubmitData.storeAlias': {
      immediate: true,
      handler(newValue, oldValue) {
        this.tryToFetchReservationCalendar()
      }
    },
    datePickerYear: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.currentDatePage()
        })
      }
    },
    datePickerMonth: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.currentDatePage()
        })
      }
    }
  },
  created() {
    const initFormMixSubmitData = () => {
      const {
        category,
        sizeAlias,
        date,
        isUserMemberPet,
        isUsePrepaid,
        petId,
        time,
        scheduleItemId,
      } = this.$route.query;

      this.FormMixSubmitData.isUserMemberPet = getDefaultIsUserMemberPet(isUserMemberPet) ?? DEFAULT_SUBMIT_DATA.isUserMemberPet;
      this.FormMixSubmitData.isUsePrepaid = getDefaultIsUsePrepaid(isUsePrepaid) ?? DEFAULT_SUBMIT_DATA.isUsePrepaid;

      this.FormMixSubmitData.petId = getDefaultPetId(petId) || DEFAULT_SUBMIT_DATA.petId;

      this.FormMixSubmitData.category = getDefaultCategoryAlias({
        queryIsUserMemberPet: this.FormMixSubmitData.isUserMemberPet,
        queryPetId: this.FormMixSubmitData.petId,
        queryCategory: category
      }) || DEFAULT_SUBMIT_DATA.category;

      this.FormMixSubmitData.sizeAlias = getDefaultSizeAlias({
        queryIsUserMemberPet: this.FormMixSubmitData.isUserMemberPet,
        queryPetId: this.FormMixSubmitData.petId,
        queryCategory: this.FormMixSubmitData.category,
        querySize: sizeAlias,
      }) || DEFAULT_SUBMIT_DATA.sizeAlias;

      this.FormMixSubmitData.storeAlias = this.storeItem.alias || DEFAULT_SUBMIT_DATA.storeAlias;
      this.FormMixSubmitData.date = getDefaultDate(date) || DEFAULT_SUBMIT_DATA.date;
      this.FormMixSubmitData.time = time ?? DEFAULT_SUBMIT_DATA.time;
      this.FormMixSubmitData.scheduleItemId = scheduleItemId || DEFAULT_SUBMIT_DATA.scheduleItemId
    };

    initFormMixSubmitData();
    this.$FormMixinOnInit()
  },
  mounted() {
    this.$refs.datePicker.showPicker()
    this.$refs.datePicker.hidePicker()
    const vm = this
    const targetYear = document.querySelectorAll('.el-date-picker__header-label')[0]
    const targetMonth = document.querySelectorAll('.el-date-picker__header-label')[1]
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach((record) => {
        const formatText = record.target.textContent.toString()
        if(formatText.includes('年') && formatText.length < 7) {
          vm.datePickerYear = formatText.split(' ')[0]
        }
        if(formatText.includes('月')) {
          vm.datePickerMonth = formatText.split(' ')[0]
        }
      });
    });

    observer.observe(targetYear, {
        childList: true,
        characterData: true,
        subtree: true,
        characterDataOldValue: true
    });
    observer.observe(targetMonth, {
        childList: true,
        characterData: true,
        subtree: true,
        characterDataOldValue: true
    });
  },
  methods: {
    formatDate,
    sizeOptions,
    getDefaultReservationDisabledDayList,
    onSubmit: _debounce(function() {
      if (this.$refs.vo.flags.invalid || !this.petIdValid || this.isIncludDisabledDayList) return
      this.$FormMixinOnSubmitSuccess()
      this.tryToFetchReservationCalendar()
    }, 500),
    onChangeIsUserMemberPet(value) {
      if (this.isLoggedIn) {
        this.onSubmit()
        return 
      }

      if(value && !this.isLoggedIn) {
        const loggedInFn = () => {
          this.$nextTick(() => {
            this.tryToFetchMemberPetList()
              .then(() => {
                this.FormMixSubmitData.petId = getDefaultPetId('') || DEFAULT_SUBMIT_DATA.petId;
                this.FormMixSubmitData.isUserMemberPet = true;
                this.onSubmit()
              });
          })
        };

        this.FormMixSubmitData.isUserMemberPet = false;

        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    onChangeIsUsePrepaid(value) {
      if (this.isLoggedIn) {
        this.onSubmit()
        return 
      }

      if(value && !this.isLoggedIn) {
        const loggedInFn = () => {
          this.$nextTick(() => {
            this.FormMixSubmitData.isUsePrepaid = true;
            this.onSubmit()
          })
        };

        this.FormMixSubmitData.isUsePrepaid = false;

        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    callbackNewPet(submitData) {
      this.FormMixSubmitData.petId = submitData.id
    },
    async tryToFetchMemberPetList() {
      await this.$store.dispatch('auth/fetchMemberPetList', {
        useCached: true
      })
        .then(() => {
          return true
        })
    },
    onChangeCategory(category) {
      const setFormMixSubmitDataSizeAlias = () => {
        const sizeOptions = this.sizeOptions(category);

        this.FormMixSubmitData.sizeAlias = sizeOptions[0]?.value || ''
      };

      setFormMixSubmitDataSizeAlias();
      this.onSubmit()
    },
    onChangePetId(petId) {
      if (petId === 'new') return

      const setFormMixSubmitDataSizeAlias = () => {
        const memberPetItem = getMemberPetOption({
          value: petId,
        });

        this.FormMixSubmitData.category = memberPetItem.categoryAlias || '';
        this.FormMixSubmitData.sizeAlias = memberPetItem.sizeAlias || '';
      };

      setFormMixSubmitDataSizeAlias();
      this.onSubmit()
    },
    onChangeDate() {
      if(!this.timeButtonList.includes(this.FormMixSubmitData.time)) {
        this.FormMixSubmitData.time = ''
      }
      this.onSubmit()
    },
    openDialogPet() {
      this.$globalDialog('DialogPet', {
        type: 'add',
        callbackNewPet: (submitData) => {
          this.FormMixSubmitData.petId = submitData.id
          this.onChangePetId(submitData.id);
          this.$emit('callbackNewPet')
        },
      })
    },
    onChangeRadioTime() {
      this.onSubmit()
    },
    onChangeSize() {
      this.onSubmit()
    },
    onChangescheduleItemId () {
      this.onSubmit()
    },
    tryToFetchReservationCalendar() {
      
      if(!this.startDate && !this.endDate) {
        return
      }
      const submitData = {
        startDate: this.startDate,
        endDate: this.endDate,
        storeAlias: this.FormMixSubmitData.storeAlias,
        sizeAlias: this.FormMixSubmitData.sizeAlias,
        servicePriceGroupId: this.FormMixSubmitData?.servicePriceGroupId || undefined,
        types: [this.serviceType],
        scheduleItemId: this.FormMixSubmitData.scheduleItemId || undefined
      }
      // this.$nextTick(() => {
        this.$store.dispatch('merchant/fetchReservationCalendar', {
          ...submitData
        })
          .then(({ items }) => {
            const currentDisabledDate = Object.keys(items).length ? Object.keys(items).filter((item) => {
              return !items[item].isOpen
            }): []
            this.currentDisabledDate = currentDisabledDate.length ? currentDisabledDate.map((item) => {
              return parseISO(item)
            }) : []
            this.formatDisabledDateTime = currentDisabledDate.length ? currentDisabledDate.map((item) => {
              return parseISO(item).getTime(

              )
            }) : []
          })
    },
    currentDatePage() {
      if (!this.datePickerYear || !this.datePickerMonth) return
      this.$refs.date.move(`${this.datePickerYear}-${this.datePickerMonth}`)
      this.getCurrentReservationCalendar()
    },
    onChangePage: _debounce(function(page) {
      this.datePickerYear = this.datePickerYear === page.year ? this.datePickerYear : page.year
      this.datePickerMonth = this.datePickerMonth === page.month ? this.datePickerMonth : page.month
    }, 500),
    getCurrentReservationCalendar() {
      const date = new Date(this.datePickerYear,(this.datePickerMonth - 1))
      const isThisCurrentYear = isThisYear(date)
      const isThisCurrentMonth = isThisMonth(date)  
      if(isThisCurrentYear && isThisCurrentMonth) {
        this.startDate =  formatDate(new Date(), 'yyyy-MM-dd');
        this.endDate = formatDate(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
      } else {
        this.startDate = formatDate(date, 'yyyy-MM-dd');
        this.endDate = formatDate(lastDayOfMonth(date), 'yyyy-MM-dd')
      }
    },
    onFocus() {
      const targetYear = document.querySelectorAll('.el-date-picker__header-label')[0].textContent.split(' ')[0]
      const targetMonth = document.querySelectorAll('.el-date-picker__header-label')[1].textContent.split(' ')[0]
      const data = {
        month: targetMonth,
        year: targetYear
      }
      this.onChangePage(data)
    },
  }
}
</script>

<!-- section style -->
<style lang="scss" module>
.formReservationStore {
  // margin-bottom: -22px;

  :global {
    .formReservationStore {
      &__submit {
        margin-top: 3px;
        // margin-bottom: 22px;
      }

      &__topBox {
        border-bottom: 1px solid $color-line;
        // padding-bottom: 1.5rem;

        @include max-lg {
          display: none;
        }
      }

      &__bottomBox {
        padding: 1.5rem 1.5rem 0;
      }

      &__submitBox {
        padding: 0 1.5rem 1.5rem;

        /* background: #fff;
        position: sticky;
        bottom: 0;
        z-index: 1;
        margin-top: -1px;
        border-top: 1px solid $color-line; */
      }
    }
  }
}
</style>
